import { render, staticRenderFns } from "./UserMasterPage.vue?vue&type=template&id=6b7afd8f&scoped=true&"
import script from "./UserMasterPage.vue?vue&type=script&lang=js&"
export * from "./UserMasterPage.vue?vue&type=script&lang=js&"
import style0 from "./UserMasterPage.vue?vue&type=style&index=0&id=6b7afd8f&lang=scss&scoped=true&"
import style1 from "./UserMasterPage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7afd8f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b7afd8f')) {
      api.createRecord('6b7afd8f', component.options)
    } else {
      api.reload('6b7afd8f', component.options)
    }
    module.hot.accept("./UserMasterPage.vue?vue&type=template&id=6b7afd8f&scoped=true&", function () {
      api.rerender('6b7afd8f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/master/cognitoUserMaster/UserMasterPage.vue"
export default component.exports